
import { Auth } from "@supabase/auth-ui-react";
import { ThemeSupa } from "@supabase/auth-ui-shared";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useTranslation } from "react-i18next";
import PageLayout from "@/components/layout/PageLayout";
import { UserPlus } from "lucide-react";

const Signup = () => {
  const navigate = useNavigate();
  const { t } = useTranslation("signup");
  const [sessionChecked, setSessionChecked] = useState(false);
  const [session, setSession] = useState<any>(null);

  useEffect(() => {
    // Set up listener for authentication
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, newSession) => {
      setSession(newSession);
      setSessionChecked(true);
      if (!newSession) {
        navigate("/login", { replace: true });
      }
    });

    // Initial session check
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      setSessionChecked(true);
      if (!session) {
        navigate("/login", { replace: true });
      }
    });

    return () => subscription.unsubscribe();
  }, [navigate]);

  // Don’t render signup until session is checked
  if (!sessionChecked) return null;

  // Only allow signup for authenticated users (manual/internal use)
  if (!session) return null;

  return (
    <PageLayout
      title={t('signup.title')}
      description={t('signup.subtitle')}
      icon={<UserPlus className="h-6 w-6" />}
    >
      <div className="min-h-[75vh] flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full space-y-8">
          <div className="mt-8 bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
            <Auth
              supabaseClient={supabase}
              appearance={{
                theme: ThemeSupa,
                variables: {
                  default: {
                    colors: {
                      brand: 'rgb(var(--color-primary))',
                      brandAccent: 'rgb(var(--color-primary))',
                    },
                  },
                },
              }}
              theme="light"
              providers={[]}
              redirectTo={`${window.location.origin}/dashboard`}
              view="sign_up"
              localization={{
                variables: {
                  sign_up: {
                    email_label: t("signup.email"),
                    password_label: t("signup.password"),
                    button_label: t("signup.createAccount"),
                    loading_button_label: t("signup.loading"),
                    social_provider_text: "Tilmeld dig med",
                    link_text: t("signup.haveAccount") + " " + t("signup.signIn"),
                    confirmation_text: t("signup.success.message")
                  }
                }
              }}
            />
          </div>
        </div>
      </div>
    </PageLayout>
  );
};

export default Signup;
